import { useContext } from 'react'
import styled from '@emotion/styled'
import { DataContext } from '../../contexts/dataContext'
import { lang } from '../../utils/lang'
import { Flex, Box } from 'rebass'
import { getFaNum } from '../../utils/helpers'
import { BASE_URL } from '../../utils/constants'
import { DonateButton } from '../atoms/Buttons'
import Arrows from '../atoms/Arrows'

const Container = styled(Box)`
  position: absolute;
  bottom: 5rem;
  left: 20px;
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 0.75rem;
`

const Count = ({ fatalNum, nonFatalNum }) => {
  const { ui } = useContext(DataContext)
  const dir = ui === 'en' ? 'ltr' : 'rtl'
  const uiLang = ui === 'fa' ? 'fa/' : ''
  const sm = true
  return (
    <Container dir={dir}>
      <Box mb={'9px'}>
        <DonateButton sm={sm}>
          <a
            href={`${BASE_URL}/${uiLang}memorial/add`}
            target="_blank"
            rel="noreferrer"
          >
            <Flex dir={dir}>
              <Box>{lang[ui]['AddToMap']}</Box>
              <Box mt={'1px'} ml={ui === 'en' ? 2 : 0} mr={ui === 'en' ? 0 : 2}>
                <Arrows
                  color="black"
                  width={sm ? '8px' : '10px'}
                  height={sm ? '10px' : '12px'}
                  flip={ui === 'fa'}
                />
              </Box>
            </Flex>
          </a>
        </DonateButton>
      </Box>
      <p>
        {ui === 'en' ? fatalNum : getFaNum(fatalNum)} {lang[ui]['Fatal']}
      </p>
      <p>
        {ui === 'en' ? nonFatalNum : getFaNum(nonFatalNum)}{' '}
        {lang[ui]['NonFatal']}
      </p>
    </Container>
  )
}

export default Count
